<template>
  <!-- <el-container class="index-con">
    <el-header class="index-header">
      <navcon></navcon>
    </el-header>
    <el-container class="index-con">
      <el-aside :class="showclass">
        <leftnav></leftnav>
      </el-aside>
      <el-container class="main-con">
        <el-main clss="index-main">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </el-container> -->



    <el-container class="main-con">

        <navcon></navcon>
        <div class="cbody">
          <transition :name="!isMobile && transitionName">
      <router-view  :no-swipe="isMobile"></router-view>
    </transition>
        </div>
    
        <foot></foot>
    </el-container>
 
</template>
<script>
// 導入組件
import { cheaklogin} from '../api/userMG'
import navcon from '../components/navcon.vue'
import foot from '../components/footer.vue'
export default {
  name: 'index',
  data() {
    return {
      userdata:{},
      bks:true,
      showclass: 'asideshow',
      showtype: false,
      transitionName: 'slide-left',
      loginbox:false,
      isMobile: false,
    }
  },
  // 註冊組件
  components: {
    navcon,
    foot
  },
  methods: {
    isMobileDevice() {
      var isMobile = document.documentElement.clientWidth > 1200 ? false : true;
    return isMobile;
  }
  },
  created() {
    this.userdata = JSON.parse(localStorage.getItem('userdata'))
  },
  mounted() {
    this.isMobile = this.isMobileDevice();
  },
  beforeUpdate() {},
  // 掛載前狀態(裏麵是操作)
  beforeMount() {
    let userjson=JSON.parse(localStorage.getItem('userdata'))
 if(userjson){

   cheaklogin(userjson).then(res => {
      if (res.code==1) {
        localStorage.setItem('userdata', JSON.stringify(res.data))    
      } else {
        localStorage.setItem('logintoken', null)
          
      localStorage.setItem('userdata', null)   
      this.$store.commit('login', 'false')
      this.$message({
                type: 'info',
                message: res.message
              }) 
      location.reload()
      }
   })
 }
  },
  watch: {
    '$route'(to, from) {

      let toName = to.name
      if(to.name=='Bookings'){this.bks=false}
      window.scrollTo(0, 0)
      const toIndex = to.meta.index
      const fromIndex = from.meta.index

      this.transitionName = toIndex < fromIndex ? 'slide-right' : 'slide-left'
      
    }
  },
}
</script>

<style>
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}
.el-scrollbar__bar{opacity: 1!important;}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue